import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { SaveStatus } from '../services/draft-manager.service';

// import {
//  MessageCreatorPage,
//  PostcardCreatorPage,
// } from "../pages";

import { PostcardCreatorPage } from '../postcard-creator/postcard-creator';
import { MessageCreatorPage } from '../message-creator/message-creator';

declare var Beacon;
declare var Penmate;

@Component({
  selector: 'edit-message-navbar',
  templateUrl: 'edit-message-navbar.html',
  styleUrls: ['./edit-message-navbar.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditMessageNavBar implements OnDestroy {
  public penmateId;
  @Input() penmate: any;
  @Input() back: any;
  @Input() hideBack: boolean;
  @Input() showDoneWriting: boolean;
  @Input() showHelp: boolean;
  @Input() showPenmateName: boolean;
  @Input() saveStatus: SaveStatus;
  @Input() destroyBeaconOnClose: boolean;
  @Input() destroyBeaconOnDestroy: boolean;
  @Input() beaconDisplayStyle: 'icon' | 'text' | 'iconAndText' | 'manual';

  private beaconCloseCleanupHandler: (() => void) | null = null;
  private helpOpenRequestId = 0;

  constructor(public navCtrl: NavController, private route: ActivatedRoute) {}

  get penmateDisplayName(): string {
    const p: any = this.penmate;
    if (!p) return '';
    const rawName =
      typeof p.name === 'string'
        ? p.name
        : typeof p.first_name === 'string' || typeof p.last_name === 'string'
          ? `${p.first_name || ''} ${p.last_name || ''}`
          : typeof p.firstName === 'string' || typeof p.lastName === 'string'
            ? `${p.firstName || ''} ${p.lastName || ''}`
            : '';
    return String(rawName || '').replace(/\s+/g, ' ').trim();
  }

  ngOnDestroy(): void {
    if (this.destroyBeaconOnDestroy) {
      this.destroyHelpScoutBeacon();
    }
  }

  private destroyHelpScoutBeacon = () => {
    if (typeof Beacon !== 'function') return;
    if (this.beaconCloseCleanupHandler) {
      try {
        Beacon('off', 'close', this.beaconCloseCleanupHandler);
      } catch (e) {
        // no-op
      }
      this.beaconCloseCleanupHandler = null;
    }
    try {
      Beacon('destroy');
    } catch (e) {
      // no-op
    }
  };

  private registerDestroyOnBeaconClose = () => {
    if (typeof Beacon !== 'function') return;
    if (this.beaconCloseCleanupHandler) {
      try {
        Beacon('off', 'close', this.beaconCloseCleanupHandler);
      } catch (e) {
        // no-op
      }
    }
    this.beaconCloseCleanupHandler = () => {
      this.destroyHelpScoutBeacon();
    };
    try {
      Beacon('on', 'close', this.beaconCloseCleanupHandler);
    } catch (e) {
      // no-op
    }
  };

  private initHelpScoutBeacon = () => {
    if (typeof Beacon !== 'function') return;
    const w: any = typeof window !== 'undefined' ? window : null;
    const beaconId = w && w.Penmate && w.Penmate.env ? w.Penmate.env.helpScoutId : null;
    if (!beaconId) return;

    if (!this.beaconDisplayStyle) {
      return Beacon('init', beaconId);
    }

    try {
      const initRes = Beacon('init', { beaconId, display: { style: this.beaconDisplayStyle } });
      try {
        Beacon('config', { display: { style: this.beaconDisplayStyle } });
      } catch (e) {
        // no-op
      }
      return initRes;
    } catch (e) {
      try {
        const initRes = Beacon('init', beaconId);
        try {
          Beacon('config', { display: { style: this.beaconDisplayStyle } });
        } catch (_e) {
          // no-op
        }
        return initRes;
      } catch (_e) {
        // no-op
      }
    }
  };

  private initHelpScoutBeaconWithRetry = (requestId: number, attempt = 0) => {
    if (requestId !== this.helpOpenRequestId) return;
    if (typeof Beacon !== 'function') return;

    const initRes = this.initHelpScoutBeacon();
    const shouldRetry = Boolean(initRes) && attempt < 8;
    if (!shouldRetry) return;

    setTimeout(() => {
      this.initHelpScoutBeaconWithRetry(requestId, attempt + 1);
    }, 250);
  };

  private openHelpScoutBeacon = (route: string, requestId: number, attempt = 0) => {
    if (requestId !== this.helpOpenRequestId) return;
    if (typeof Beacon !== 'function') return;

    try {
      Beacon('navigate', route);
    } catch (e) {
      // no-op
    }
    try {
      Beacon('open');
    } catch (e) {
      // no-op
    }

    let isOpen = false;
    try {
      isOpen = Boolean(Beacon('isOpen'));
    } catch (e) {
      // no-op
    }

    if (isOpen || attempt >= 10) return;
    setTimeout(() => {
      this.openHelpScoutBeacon(route, requestId, attempt + 1);
    }, 200);
  };

  onShowHelpWidget(route = '/ask/') {
    if (typeof Beacon !== 'function') return;

    this.helpOpenRequestId = this.helpOpenRequestId + 1;
    const requestId = this.helpOpenRequestId;

    if (this.destroyBeaconOnClose) {
      this.registerDestroyOnBeaconClose();
    }

    this.initHelpScoutBeaconWithRetry(requestId);
    this.openHelpScoutBeacon(route, requestId);
  }

  onGoBack() {
    if (this.back) {
      return this.back();
    }
    const penmateId = this.route.snapshot.paramMap.get('id');
    if (!penmateId) {
      return false;
    }
    const isPostcard = /new-postcard/.test(document.location.href);
    // const component = isPostcard ? PostcardCreatorPage : MessageCreatorPage;
    const routePath = isPostcard
      ? `/penmates/${penmateId}/new-postcard`
      : `/penmates/${penmateId}/new-message`;
    this.navCtrl.navigateBack(routePath);
  }

  onDoneWriting() {
    return true;
  }
}
